module.exports = __webpack_public_path__ + "img/LIGHTING 2 PURPLE.bcb7618.svg";